<template>
  <div>
    <div :class="{ fullscreen: fullscreen }" class="tinymce-container">
      <div v-if="disabled" class="transparent-bg"></div>
      <textarea :id="tinymceId" class="tinymce-textarea" />
    </div>
    <div v-if="showLoading" class="float-center" style="z-index: 999999999">
      <div @click="closeLoading" class="flex-align-center">
        <div>
          <show-progress
            dataName="editorUpload"
            style="margin-right: 10px; z-index: 99999; width: 100px"
          ></show-progress>
        </div>
        <span style="font-size: 25px">文件上传，请等待(点击关闭)</span>
      </div>
    </div>
    <div v-if="showImgLoading" class="float-center">
      <div style="font-size: 25px" @click="closeImgLoading">
        <div style="text-align: center">
          <el-progress type="circle" :percentage="currentRate"></el-progress>
        </div>
        <span style="font-size: 25px">图片上传，请等待(点击关闭)</span>
        <!-- <t-loading style="margin-right: 10px" />图片上传中，请等待(点击关闭) -->
      </div>
    </div>
    <image-edit ref="imageEdit" @change="setImageUrl"></image-edit>
    <chose-from-vod @change="file_callback" ref="mediaVod"></chose-from-vod>
    <el-dialog
      title="转存媒资库"
      width="500px"
      :visible.sync="vodDialog"
      append-to-body
      class="dialog-index-max"
    >
      <div class="flex-center">
        文件标题<el-input
          v-model="title"
          style="width: 300px; margin-left: 10px"
          placeholder="文件标题"
        ></el-input>
      </div>
      <span slot="footer">
        <el-button
          style="margin-left: 10px"
          size="small"
          @click="vodDialog = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          style="margin-left: 10px"
          size="small"
          @click="save_to_vod"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="添加方式选择"
      width="260px"
      :visible.sync="uploadMethod"
      append-to-body
      class="dialog-index-max"
    >
      <div style="display: flex">
        <el-button type="primary" :disabled="!power['查看']" @click="openVod"
          >媒资库导入</el-button
        >
        <el-button type="primary" style="margin-left: 10px" @click="choseFile"
          >本地上传</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { uploadFile } from "@/server/api/cos.js";
import uploadFileImg from "@/server/api/file.js";
import upload from "@/server/api/imgDump.js";
import showProgress from "@/components/uploadProgress/showProgress.vue";
import configure from "./plugins";
// import "tinymce-plugin/plugins/tpLayout/plugin.js";
import "./tpLayoutPlugin";
import "./powerpaste/plugin.min.js";
import ImageEdit from "@/components/ImageEdit.vue";
import { saveToVod, saveToVodBatch } from "@/server/api/mediaLibrary.js";
import ChoseFromVod from "@/components/choseFromVod/ChoseFromVod.vue";
import { getEditSign } from "@/server/api/cos.js";
import { uploadAttachment } from "@/server/api/attachment.js";
import {
  forbidMediaDownload,
  addAttrToTagVideo,
  filterTagsAttrs,
  waitTime,
} from "@/util/fun.js";
import { getVideoPoster } from "@/server/api/file.js";
// import "/libs/tinymce/lang";
export default {
  components: {
    showProgress,
    ImageEdit,
    ChoseFromVod,
  },
  name: "Tinymce",
  props: {
    value: {
      type: String,
      default: "",
    },
    height: {
      type: [Number, String],
      required: false,
      default: 900,
    },
    imageMaxWidth: {
      type: String,
      default: "80%",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    canSetCover: {
      type: Boolean,
      default: false,
    },
    canSetShareCover: {
      type: Boolean,
      default: false,
    },
    fromFunction: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      showImgLoading: false,
      showLoading: false,
      hasChange: false,
      hasInit: false,
      tinymceId:
        "vue-tinymce-" + +new Date() + ((Math.random() * 1000).toFixed(0) + ""),
      fullscreen: false,

      currentRate: 0,
      file: null,
      fileList2: [],

      ruleForm: {
        coverUrl: "",
        coverFile: "",
      },
      setImageUrl: () => {},
      videoWidth: "",
      videoHeight: "",
      videoPoster: "",
      power: {}, //媒资库权限
      vodDialog: false,
      title: "",
      type: "",
      url: "",
      uploadMethod: false,
      choseFile: () => {},
      file_callback: () => {},
      file_type: "audio", //vod返回的文件类型
      file_info: {},
      isEditImg: false,
      uploadVideos: false,
    };
  },

  computed: {},

  watch: {
    value(val) {
      // if (!this.hasChange && this.hasInit) {
      console.log(val);
      this.$nextTick(() => {
        window.tinymce.get(this.tinymceId).setContent(val || "");
        //解决自动保存 光标跳到最前
        // window.tinymce.activeEditor.selection.select(
        //   window.tinymce.activeEditor.getBody(),
        //   true
        // );
        // window.tinymce.activeEditor.selection.collapse(false);
      });
      // }
    },
  },

  created() {
    this.clearLocalStorage();
  },
  mounted() {
    window.editor_videoPoster = getVideoPoster;
    window.editor_setCover = this.canSetCover;
    window.editorSetCover = this.setCover;
    window.editor_setShareCover = this.canSetShareCover;
    window.editorSetShareCover = this.setShareCover;
    this.power = this.utils.currentPower("媒体资源库管理");
    this.initTinymce();
    window.editImage = this.changeImageUrl;
    //批量上传转存到媒资库
    window.toMediaLibrary = this.toMediaLibraryBatch;
    // navigator.clipboard.read().then((value) => {
    //   console.log(value);
    //   // text 就是剪贴板的内容
    // });
    //添加链接时允许上传文件
    window.uploadLinkFile = this.uploadLinkFile;
  },

  activated() {
    if (window.tinymce) {
      this.initTinymce();
    }
  },

  deactivated() {
    this.destroyTinymce();
  },

  destroyed() {
    this.destroyTinymce();
  },

  methods: {
    clearLocalStorage() {
      for (let i in localStorage) {
        if (i.indexOf("tinymce-autosave") == 0) {
          localStorage.removeItem(i);
        }
      }
    },
    closeLoading() {
      this.showLoading = false;
    },
    closeImgLoading() {
      this.showImgLoading = false;
    },
    initTinymce() {
      const _this = this;
      window.tinymce.init({
        selector: `#${this.tinymceId}`,
        // selector: "#textarea1",
        // toolbar: "forecolor backcolor",
        menu: false,
        menubar: false,
        cleanup_on_startup: true,
        fix_list_elements: false,
        fix_nesting: false,
        fix_table_elements: false,
        paste_use_dialog: true,
        paste_auto_cleanup_on_paste: true,
        language_url: "/libs/tinymce/langs/zh_CN.js",
        language: "zh_CN", //注意大小写
        file_picker_types: "image media",
        automatic_uploads: true,
        templates: [
          {
            title: "插入居中图片",
            description: "",
            content: `<p class='mceNonEditable'>
                <span  class="img-section mceEditable" style='width:50%;margin:0 auto;display:block;'>
                  <img class="mceEditable" src="./img/relepaceEditor.jpg"></img>
                </span>
              </p>`,
          },
        ],
        // content_style: `
        //   iframe  { width: 100%; },
        //   img {max-width:100px;max-height:200px;vertical-align:top}
        // `,
        content_style:
          "img {max-width:" +
          this.imageMaxWidth +
          ";height:auto;display: block; margin: 0 auto;};p {style=text-align: justify; line-height: 1.8; margin: 0.75rem 0rem; font-size: 18px;}.img-section img {width:100%;max-width:100%;height:auto !important;}",
        // content_style: "br {line-height: 0;height: 50px display: block}",

        directionality: "ltr",
        forced_root_block: "p",
        height: "calc(100vh - 252px)",
        body_class: "panel-body",
        object_resizing: false,
        plugins: configure.plugins,
        toolbar: configure.toolbar,
        remove_linebreaks: true,
        tp_layout_options: {
          style: {
            "text-align": "justify",
            "line-height": "1.8",
            margin: "0.75rem 0rem 0.75rem 0rem",
            "font-size": "18px",
            "font-bold": "0px",
            // fontfamily:
            //   "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;默认字体=-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', SimSun, sans-serif, SimSun;Book Antiqua=book antiqua,palatino;",
            fontfamily:
              "Arial=arial;苹果苹方=PingFang SC,苹果平方;微软雅黑/兰亭黑体=微软雅黑,Microsoft YaHei,Lantinghei SC,Helvetica Neue,sans-serif;宋体=宋体,simsun,Songti SC,SimSong,serif;仿宋体=FangSong,仿宋体,serif;黑体=黑体,SimHei,Heiti SC,sans-serif;Sans Serif=sans-serif;Helvetica=helvetica;Book Antiqua=book antiqua,palatino;",
          },
          filterTags: ["br"], //'table，'tbody','td','tr' 将会忽略掉 同时 table>*，忽略table 标签 以及所有子标签
          clearStyle: ["color", "text-indent"], //text-indent 将会被清除掉
          tagsStyle: {
            section: {
              "text-align": "justify",
              "line-height": "1.8",
              margin: "0.75rem 0rem 0.75rem 0rem",
              "font-size": "18px",
              "font-bold": "0px",
              fontfamily:
                "Arial=arial;苹果苹方=PingFang SC,苹果平方;微软雅黑/兰亭黑体=微软雅黑,Microsoft YaHei,Lantinghei SC,Helvetica Neue,sans-serif;宋体=宋体,simsun,Songti SC,SimSong,serif;仿宋体=FangSong,仿宋体,serif;黑体=黑体,SimHei,Heiti SC,sans-serif;Sans Serif=sans-serif;Helvetica=helvetica;Book Antiqua=book antiqua,palatino;",
            },
            table: {
              "line-height": 3,
              "text-align": "center",
            },
            "table,tbody,tr,td": {
              //支持并集选择
              "line-height": 2,
            },
            "tr>td,table>tbody": {
              //支持, 精准定位 通过 ' > '
              "line-height": 3,
              "text-align": "center",
            },
            span: {},
          },
        },

        lineheight_formats: configure.lineheight,
        fontsize_formats: configure.fontsize,
        font_formats: configure.fontfamily,
        element_format: "html",
        // entity_encoding: "raw",
        image_dimensions: true,
        readonly: this.readonly,
        media_live_embeds: true,
        toolbar_sticky: false,
        relative_urls: false,
        remove_script_host: false,

        // auto_focus: true,
        relative_urls: false,
        cleanup: false,
        verify_html: false,
        // image_template_callback:function(data){
        //   console.log('图片回调',data)
        // },
        video_template_callback: function(data) {
          console.log("处理回调", data);
          data.poster = _this.videoPoster;
          if (
            data.source.indexOf("audio") != -1 ||
            _this.file_type === "audio"
          ) {
            return (
              "<audio controls>" +
              '\n<source src="' +
              data.source +
              '"' +
              (data.sourcemime ? ' type="' + data.sourcemime + '"' : "") +
              " />\n" +
              "</audio>"
            );
          }
          return `<p style="display:flex;justify-content: center;"><video poster="${data.poster}" src="${data.source}" width="350px" height="auto" controls="controls"></video></p>`;
          //   return (
          //     '<span class="mce-preview-object mce-object-video" style="display:flex;justify-content: center;border: 0;" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" data-mce-p-src=' +
          //     data.source +
          //     " data-mce-p-width=" +
          //     _this.videoWidth +
          //     " data-mce-p-height=" +
          //     _this.videoHeight +
          //     ' data-mce-p-controls="controls" data-mce-html="%20"> <video width=' +
          //     _this.videoWidth +
          //     " height=" +
          //     _this.videoHeight +
          //     ' controls="controls"> <source src=' +
          //     data.source +
          //     " type=" +
          //     data.sourcemime +
          //     "></source> </video> </span>"
          //   );
        },

        // video_template_callback: function (
        //   data,
        //   width,
        //   height,
        //   poster,
        //   source1,
        //   source1mime,
        //   source2,
        //   source2mime
        // ) {
        //   console.log(data);
        //   if (data.source.indexOf("audio") != -1) {
        //     return (
        //       '<span class="mce-preview-object mce-object-video" style="border: 0;" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" data-mce-p-src=' +
        //       data.source +
        //       " data-mce-p-width=" +
        //       data.width +
        //       " data-mce-p-height=" +
        //       data.height +
        //       ' data-mce-p-controls="controls" data-mce-html="%20"> <audio width=' +
        //       data.width +
        //       " height=" +
        //       data.height +
        //       ' controls="controls"> <source src=' +
        //       data.source +
        //       " type=" +
        //       data.sourcemime +
        //       "></source> </audio> </span>"
        //     );
        //   }
        //   return (
        //     '<span class="mce-preview-object mce-object-video" style="display:flex;justify-content: center;border: 0;" contenteditable="false" data-mce-object="video" data-mce-p-allowfullscreen="allowfullscreen" data-mce-p-frameborder="no" data-mce-p-scrolling="no" data-mce-p-src=' +
        //     data.source +
        //     " data-mce-p-width=" +
        //     data.width +
        //     " data-mce-p-height=" +
        //     data.height +
        //     ' data-mce-p-controls="controls" data-mce-html="%20"> <video width=' +
        //     data.width +
        //     " height=" +
        //     data.height +
        //     ' controls="controls"> <source src=' +
        //     data.source +
        //     " type=" +
        //     data.sourcemime +
        //     "></source> </video> </span>"
        //   );
        // },

        // formats:{
        //   remove: 'none',
        // },
        // valid_elements : 'img[!src],video[!src],strong/b,p,div,a',
        // end_container_on_empty_block: true,
        // powerpaste_word_import: 'clean',
        // advlist_bullet_styles: 'square',
        // advlist_number_styles: 'default',
        // imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
        // default_link_target: '_blank',
        // link_title: false,
        // nonbreaking_force_tab: true,
        // resize: false,//控制是否可以拖拽
        file_picker_callback: function(callback, value, meta) {
          _this.file_type = "";
          console.log(meta.filetype);
          if (meta.filetype == "image") {
            let input = document.createElement("input"); //创建一个隐藏的input
            input.setAttribute("accept", "image/*");
            input.setAttribute("type", "file");
            input.onchange = function() {
              let file = this.files[0]; //选取第一个文件
              _this.imageCheck(file, callback);
            };
            // 触发点击
            if (_this.power["查看"]) {
              _this.uploadMethod = true;
              _this.file_callback = callback;
              _this.choseFile = () => {
                _this.file_type = "";
                input.click();
                _this.uploadMethod = false;
              };
              _this.type = "image";
              return;
            }
            input.click();
          }
          if (meta.filetype == "media") {
            _this.url = "";
            console.log(meta.filetype);
            let input = document.createElement("input"); //创建一个隐藏的input
            input.setAttribute("type", "file");
            input.setAttribute(
              "accept",
              ".mp3, .mp4,.audio/mpeg,.audio/mp3,.audio"
            );

            // else if (file.type == 'audio/mpeg' || file.type == 'audio/mp3' || file.type.indexOf('audio') != -1)
            // input.setAttribute("accept", ".mp4");
            input.onchange = function() {
              _this.showMediaLibraryCheckbox();
              let file = this.files[0]; //选取第一个文件
              _this.uploadVideo(file, callback);
            };
            if (_this.power["查看"]) {
              _this.uploadMethod = true;
              _this.file_callback = (obj) => {
                if (obj.type == "audio") {
                  _this.file_type = "audio";
                  callback(obj.url);
                  return;
                }
                if (obj.cover) {
                  _this.videoPoster = obj.cover;
                }
                _this.file_type = "";
                _this.videoWidth = "auto";
                _this.videoHeight = "auto";
                /*   let time = new Date().getTime();
                _this.getVideoMsg(obj.url).then((videoinfo) => {
                  //获取到视频的时长,高度,宽度
                  // console.log("视频信息", videoinfo);
                  // console.log("时间差", new Date().getTime() - time);
                  const { duration, height, width } = videoinfo;
                  if (width > 1200) {
                    _this.videoWidth = 1200;
                    _this.videoHeight = "auto";
                  } else {
                    _this.videoWidth = width;
                    _this.videoHeight = height;
                  }
                  callback(obj.url);
                }); */
                // callback(obj.url, {
                //   source2: obj.url,
                //   poster: _this.videoPoster,
                // });
                callback(obj.transcodeUrl, {
                  source2: obj.transcodeUrl,
                  poster: _this.videoPoster,
                });
              };
              _this.choseFile = () => {
                _this.file_type = "";
                input.click();
                _this.uploadMethod = false;
              };
              _this.type = "media";
              return;
            }
            //触发点击
            input.click();
          }
        },

        init_instance_callback: (editor) => {
          // editor.activeEditor.undo();
          var btns = document.getElementsByClassName("tox-tbtn")[0];
          btns.onclick = function() {
            var arrPattern = [
              "<p(>|\\s+[^>]*>)(&nbsp|&nbsp;|\\s|　|<br\\s*(/)?>)*</p(>|\\s+[^>]*>)",
              "(<br\\s*(/)?>((\\s|&nbsp;|&nbsp|　)*)){2,}",
              "(<p(>|\\s+[^>]*>))((&nbsp|&nbsp;|\\s)*<br\\s*(/)?>)*((.|\n|\r)*?</p(>|\\s+[^>]*>))",
            ];
            var arrReplace = ["", "<br />$3", "$1$6"];
            let editText = _this.getContent();
            editText = editText.replaceAll(
              /<header\b[^>]*>(.*?)<\/header>/gs,
              "<p>$1</p>"
            );
            editText = editText.replaceAll(
              /<div\b[^>]*>(.*?)<\/div>/gs,
              "<p>$1</p>"
            );
            // editText = editText.replaceAll(
            //   /<section\b[^>]*>(.*?)<\/section>/gs,
            //   "<p>$1</p>"
            // );
            editText = editText.replaceAll(
              /<figure\b[^>]*>(.*?)<\/figure>/gs,
              "<p>$1</p>"
            );
            // editText = editText.replaceAll(
            //   /<strong\b[^>]*>(.*?)<\/strong>/gs,
            //   "$1"
            // );
            editText = editText.replaceAll(
              /<h1\b[^>]*>(.*?)<\/h1>/gs,
              "<p>$1</p>"
            );
            editText = editText.replaceAll(
              /<h2\b[^>]*>(.*?)<\/h2>/gs,
              "<p>$1</p>"
            );
            editText = editText.replaceAll(
              /<h3\b[^>]*>(.*?)<\/h3>/gs,
              "<p>$1</p>"
            );
            editText = editText.replaceAll(
              /<span\b[^>]*>(.*?)<\/span>/gs,
              "$1"
            );
            editText = editText.replaceAll(
              /<em\b[^>]*>(.*?)<\/em>/gs,
              "<p>$1</p>"
            );

            editText = editText.replaceAll(
              "<br>",
              '</p><p style="text-align: justify; line-height: 1.8; margin: 0.75rem 0rem; font-size: 18px;">'
            );

            const regex = /onerror="[^"]*"|onclick="[^"]*"|onload="[^"]*"/g;
            editText = editText.replace(regex, "");

            editText = _this.formatTagP(editText);
            editText = _this.formatTagSection(editText);
            for (var i = 0; i < arrPattern.length; i++) {
              var arrRegExp = new RegExp(arrPattern[i], "img");
              editText = editText.replace(arrRegExp, arrReplace[i]);
            }

            editor.setContent(editText);
          };
          editor.on("paste", async (evt) => {
            // 监听粘贴事件
            // 实现图片粘贴上传
            // const cursorIndex = tinymce.activeEditor.selection.getBookmark(
            //   2,
            //   true
            // ); //记录光标位置
            // setTimeout(() => {
            //   _this.clearEvent();
            //   tinymce.activeEditor.selection.moveToBookmark(cursorIndex); //新增后回到之前光标位置
            // }, 200);
            await waitTime(200);
            const doc = editor.getDoc(); //获取内容DOM
            filterTagsAttrs(doc);
            const items = doc.getElementsByTagName("img");
            if (items.length) {
              const content = _this.getContent();
              let srcArr = [];
              let imgReg = /<img.*?(?:>|\/>)/gi; //匹配图片中的img标签
              let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i; // 匹配图片中的src
              let arr = content.match(imgReg); //筛选出所有的img
              for (let i = 0; i < arr.length; i++) {
                if (items[i].src.indexOf("ap-guangzhou.myqcloud.com") == -1) {
                  let src = arr[i].match(srcReg);
                  // 获取图片地址
                  srcArr.push(src[1]);
                }
              }
              for (let i = 0; i < items.length; i++) {
                let src = items[i].getAttribute("_src") || items[i].src || "";
                let params = {
                  url: src,
                };
                if (items[i].src.indexOf("ap-guangzhou.myqcloud.com") == -1) {
                  upload.imageDump(params).then((res) => {
                    items[i].src = res.data;
                    items[i].dataset.mceSrc = res.data;
                  });
                }
              }
            }
          });
          if (_this.value) {
            editor.setContent(_this.value);
          }
        },

        images_upload_handler: function(blobInfo, succFun, failFun, progress) {
          var file = blobInfo.blob(); //转化为易于理解的file对象
          //导入word图片上传处理
          if (!file.name && file.type.indexOf("image") != -1) {
            file.name = file.size + "." + file.type.split("/")[1];
            // _this.imageCheck2(file, succFun, failFun);
          }
          //上传视频
          if (file.name.indexOf("mp4") != -1) {
            _this.uploadVideo(
              file,
              (res) => {
                let videoInfo = {
                  url: res,
                  height: _this.videoHeight,
                  width: _this.videoWidth,
                };
                // res.height = _this.videoHeight;
                // res.width = _this.videoWidth;
                succFun(res + "$" + JSON.stringify(videoInfo));
              },
              true
            );
          } else {
            _this.imageCheck2(file, succFun, failFun);
          }
          return;
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open("POST", env.API_HOST + "/upload");
          // xhr.upload.onprogress = function (e) {
          //   console.log(e);
          //   progress((e.loaded / e.total) * 100);
          //   let timer = (e.loaded / e.total) * 100;
          // };
          xhr.setRequestHeader(
            "x-auth-token",
            _this.cookies.getCookie("token")
          );
          xhr.onload = function() {
            var json;
            if (xhr.status != 200) {
              failFun("HTTP Error: " + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);
            if (!json || typeof json.data != "string") {
              failFun("Invalid JSON: " + xhr.responseText);
              return;
            }
            succFun(json.data);
          };
          formData = new FormData();
          formData.append("file", file, file.name);
          xhr.send(formData);
        },
        setup(editor) {
          editor.on("FullscreenStateChanged", (e) => {
            _this.fullscreen = e.state;
          });
          editor.on("init", function(e) {
            this.getBody().style.fontSize = "18px";
            // this.getBody().style.fontFamily = "simsun,serif";
            this.getBody().style.fontFamily = "arial";
            this.getBody().style.lineHeight = "1.8";
          });
        },
      });
    },
    //去除段落p标签开头和结尾的空格
    formatTagP(content) {
      let str = content;
      let reg6 = /<p[^><]{0,}>((&nbsp;){0,}\s{0,}(&ensp;){0,}(&emsp;){0,}(&thinsp;){0,}(&zwnj;){0,}(&zwj;){0,}){0,}/g;
      let arr1 = str.match(reg6).filter((item) => {
        return item !== "<p>";
      });
      if (arr1 && arr1[0]) {
        arr1.forEach((item) => {
          if (item.indexOf("<p>") !== -1) {
            str = str.replace(item, "<p>");
          } else {
            str = str.replace(item, item.substr(0, item.indexOf(">") + 1));
          }
        });
      }

      let reg7 = /((&nbsp;){0,}\s{0,}(&ensp;){0,}(&emsp;){0,}(&thinsp;){0,}(&zwnj;){0,}(&zwj;){0,}){0,}<[/]{1,1}p>/g;
      let arr2 = str.match(reg7).filter((item) => {
        return item != "</p>";
      });
      if (arr2 && arr2[0]) {
        arr2.forEach((item) => {
          str = str.replace(item, "<p>");
        });
      }
      return str;
    },
    //去除section标签开头和结尾的空格
    formatTagSection(content) {
      let str = content;
      let reg = /<section[^><]{0,}>((&nbsp;){0,}(\s){0,}(&ensp;){0,}(&emsp;){0,}(&thinsp;){0,1}(&zwnj;){0,1}(&zwj;){0,1}){0,}/g;
      let arr = str.match(reg);
      console.log("section匹配1", JSON.parse(JSON.stringify(arr)));
      if (arr && arr[0]) {
        arr = arr.filter((item) => {
          return item !== "<section>";
        });
        if (arr && arr[0]) {
          arr.forEach((item) => {
            if (item.indexOf("<section>") !== -1) {
              str = str.replace(item, "<section>");
            } else {
              str = str.replace(item, item.substr(0, item.indexOf(">") + 1));
            }
          });
        }
      }
      if (str.indexOf("</section>") != -1) {
        reg = /((&nbsp;){0,}(\s){0,}(&ensp;){0,}(&emsp;){0,}(&thinsp;){0,1}(&zwnj;){0,1}(&zwj;){0,1}){0,}<\/section>/g;
        arr = str.match(reg);
        console.log("section匹配2", JSON.parse(JSON.stringify(arr)));
        if (arr && arr[0]) {
          arr = arr.filter((item) => {
            return item != "</section>";
          });
          if (arr && arr[0]) {
            +arr.forEach((item) => {
              str = str.replace(item, "</section>");
            });
          }
        }
      }

      return str;
    },
    destroyTinymce() {
      const tinymce = window.tinymce.get(this.tinymceId);
      if (this.fullscreen) {
        tinymce.execCommand("mceFullScreen");
      }

      if (tinymce) {
        tinymce.destroy();
      }
    },

    setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },

    getContent() {
      return this.changeLink(
        addAttrToTagVideo(window.tinymce.get(this.tinymceId).getContent())
      );
    },

    setText(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    },

    getText() {
      return window.tinymce.get(this.tinymceId).getContent({ format: "text" });
    },
    getContentText(str) {
      let reg = /[>]{1,1}[^><]{1,}[<]{1,1}/g;
      let reg1 = /[>]{1,1}[^><]{1,}[>]{1,1}/g;
      let reg2 = /[<]{1,1}[^><]{1,}[<]{1,1}/g;

      let arr = str.match(reg);
      let arr1 = str.match(reg1);
      let arr2 = str.match(reg2);
      let arr3 = str.match(
        /(?<=<p style="text-align: justify; line-height: 2; margin: 0.75rem 0rem; font-size: 18px;">).*?(?=<\/p>)/g
      );
      console.log(arr3);
      // let temp = editText.replace(/(^\s*|\s*$)/g, ""); //去除正文中首尾空格
      if (!Array.isArray(arr)) {
        arr = [];
      }
      if (!Array.isArray(arr1)) {
        arr1 = [];
      }
      if (!Array.isArray(arr2)) {
        arr2 = [];
      }
      if (!Array.isArray(arr3)) {
        arr3 = [];
      }
      arr.forEach((item) => {
        console.log(item);
        // str = str.replace(item, item.replace(/\s+/g, ""));
        str = str.replace(item, item.replace(/\s+/g, ""));
      });
      arr1.forEach((item) => {
        str = str.replace(item, item.replace(/\s+/g, ""));
      });
      arr2.forEach((item) => {
        str = str.replace(item, item.replace(/\s+/g, ""));
      });
      arr3.forEach((item) => {
        str = str.replace(item, item.replace(/(^\s*|\s*$)/g, ""));
      });
      return str;
    },
    // 上传本地图片
    uploadImg(file, type, callback) {
      let _that = this;
      _that.currentRate = 0;
      this.showImgLoading = true;
      let content = file;
      let formData = new FormData();
      formData.append("file", content);
      axios({
        method: "post",
        //服务器上传地址
        url: env.API_HOST + "/upload",
        data: formData,
        headers: {
          "x-auth-token": this.cookies.getCookie("token"),
        },

        onUploadProgress: function(progressEvent) {
          //原生获取上传进度的事件
          if (progressEvent.lengthComputable) {
            //属性lengthComputable主要表明总共需要完成的工作量和已经完成的工作是否可以被测量
            //如果lengthComputable为false，就获取不到progressEvent.total和progressEvent.loaded
            // console.log(progressEvent);
            _that.callback1(progressEvent);
          }
        },
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success("图片上传成功");
          let resimg = res.data;
          this.showImgLoading = false;
          callback(resimg);
        } else {
          this.showImgLoading = false;
          this.$message.warning("图片上传失败");
        }
      });
    },
    //图片检查
    imageCheck(data, callback, flag) {
      if (data.size / 1024 / 1024 > 32) {
        this.info("图片大小不能超过32MB");
        return;
      }
      let that = this;
      console.log(flag);
      let Url = "";
      if (typeof data == "object") {
        Url = URL.createObjectURL(data);
      } else {
        Url = data;
      }
      console.log("Url", Url);
      let imgObj = new Image();
      imgObj.onload = function() {
        window.URL.revokeObjectURL(Url);
        // console.log("宽", imgObj.width, "高", imgObj.height);
        if (imgObj.width > 30000 || imgObj.height > 30000) {
          that.info("上传图片宽高不能超过30000 x 30000");
        } else {
          that.beginUploadImg(data, callback, flag);
        }
      };
      imgObj.src = Url;
    },
    beginUploadImg(file, callback, flag) {
      this.fileInfo = {
        name: file.name,
        size: file.size,
        type: this.type,
        file: file,
      };
      if (!flag) {
        this.showLoading = true;
      }
      file.fromArticle = this.fromFunction === "article";
      uploadFile(file, "editorUpload").then((res) => {
        this.showLoading = false;
        if (res.status == "fail") {
          this.warning("图片上传失败");
          return;
        } else if (res.status == "success") {
          if (!flag) {
            this.$message.success("图片上传成功");
          }
          this.setImageUrl = (url) => {
            setTimeout(() => {
              console.log("内容", this.getContent());
            }, 2000);
            callback(url);
          };
          console.log("图片处理", callback);
          this.$refs.imageEdit.showModal(res, this.fileInfo);
        }
      });
    },

    //图片检查
    imageCheck2(data, succFun, failFun) {
      if (data.size / 1024 / 1024 > 32) {
        failFun("图片大小不能超过32MB");
        return;
      }
      let that = this;
      let Url = "";
      if (typeof data == "object") {
        Url = URL.createObjectURL(data);
      } else {
        Url = data;
      }
      console.log("Url", Url);
      let imgObj = new Image();
      imgObj.onload = function() {
        window.URL.revokeObjectURL(Url);
        // console.log("宽", imgObj.width, "高", imgObj.height);
        if (imgObj.width > 30000 || imgObj.height > 30000) {
          // that.info("上传图片宽高不能超过30000 x 30000");
          failFun("上传图片宽高不能超过30000 x 30000");
        } else {
          that.beginUploadImg2(data, succFun, failFun);
        }
      };
      imgObj.src = Url;
    },
    beginUploadImg2(file, succFun, failFun) {
      file.fromArticle = this.fromFunction === "article";
      uploadFile(file, "editorUpload").then((res) => {
        if (res.status == "fail") {
          failFun("图片上传失败");
          return;
        } else if (res.status == "success") {
          // this.$message.success("图片上传成功");
          succFun(res.response.url);
        }
      });
    },
    uploadVideo(file, callback, uploads) {
      if (uploads) {
        this.uploadVideos = true;
      } else {
        this.uploadVideos = false;
      }
      if (file.type.indexOf("video") != -1) {
        this.type = "video";
      } else if (file.type.indexOf("audio") != -1) {
        this.type = "audio";
      }
      this.title = file.name.substring(0, file.name.lastIndexOf("."));
      this.showLoading = true;
      this.getVideoMsg(file).then((videoinfo) => {
        //获取到视频的时长,高度,宽度
        const { duration, height, width } = videoinfo;
        if (width > 1200) {
          this.videoWidth = "350px";
          this.videoHeight = "auto";
        } else {
          this.videoWidth = "350px";
          this.videoHeight = "auto";
        }
      });
      file.fromArticle = this.fromFunction === "article";
      uploadFile(file, "editorUpload").then((res) => {
        this.videoPoster = "";
        if (res.status == "fail") {
          this.warning("上传失败");
          this.showLoading = false;
          return;
        } else if (res.status == "success") {
          this.showLoading = false;
          this.$message.success("上传成功");
          if (this.power["添加"]) {
            //视频音频上传弹窗展示是否转存到媒资库的选项editorToMediaLibrary
            if (!this.uploadVideos && window.editorToMediaLibrary) {
              this.vodDialog = true;
            }
            this.url = res.response.url;
          }
          if (file.type.indexOf("video") !== -1) {
            //只有视频才做这个封面处理
            let sendImgUrl = res.response.url.split(".mp4")[0] + "_0.jpg";
            uploadFileImg
              .fileImg(sendImgUrl, file.fromArticle)
              .then((resp) => {
                if (resp.code === 0) {
                  this.videoPoster = resp.data.url;
                  callback(res.response.url, {
                    poster: this.videoPoster,
                  });
                } else {
                  this.videoPoster = sendImgUrl;
                  callback(res.response.url, {
                    poster: this.videoPoster,
                  });
                }
              })
              .catch(() => {
                this.videoPoster = sendImgUrl;
                callback(res.response.url, {
                  poster: this.videoPoster,
                });
              });
          } else {
            callback(res.response.url);
          }
        }
      });
    },
    callback1(progressEvent) {
      this.currentRate = Math.trunc(
        (progressEvent.loaded / progressEvent.total) * 100
      );
    },

    //获取file 高宽
    getVideoMsg(file) {
      return new Promise((resolve) => {
        let videoElement = document.createElement("video");
        if (typeof file == "string") {
          videoElement.src = file;
        } else {
          videoElement.src = URL.createObjectURL(file);
        }
        videoElement.addEventListener("loadedmetadata", function() {
          resolve({
            duration: videoElement.duration,
            height: videoElement.videoHeight,
            width: videoElement.videoWidth,
          });
        });
      });
    },

    //转存到媒资库
    save_to_vod() {
      if (!this.title) {
        this.info("标题不能为空");
      } else {
        console.log("转存参数", {
          url: this.url,
          title: this.title,
          type: this.type,
        });
        saveToVod({
          url: this.url,
          title: this.title,
          type: this.type,
        }).then((res) => {
          if (res.code === 0) {
            this.success("后台转存中");
            this.vodDialog = false;
          } else {
            this.warning(res.msg);
          }
        });
      }
    },

    //打开媒资库选择弹窗
    openVod() {
      if (this.type == "media") {
        this.$refs.mediaVod.openModal("video", true, { videoOrAudio: true });
      } else {
        this.$refs.mediaVod.openModal(this.type);
      }

      this.uploadMethod = false;
    },
    changeImageUrl(_url) {
      let url = decodeURI(decodeURI(_url));
      getEditSign(url).then((res) => {
        if (res.status == "success") {
          let end = res.response.url.indexOf("%3F");
          if (end == -1) {
            end = res.response.url.indexOf("?");
          }
          //中文名需要显示中文名pathName才能编辑，因为cos对中文名图片地址编码了两次
          res.response.opt.pathName = decodeURI(
            decodeURI(
              res.response.url.substring(
                res.response.url.indexOf("myqcloud.com") + 12,
                end
              )
            )
          );
          // console.log("获取的信息", res);
          res.response.url = url;
          this.$refs.imageEdit.showModal(
            res,
            { name: "" },
            { source: "imageEdit" }
          );
          this.setImageUrl = window.setImgValue;
        } else {
          this.warning("签名链接获取失败");
          console.log(res);
        }
      });
    },
    toMediaLibraryBatch(arr) {
      console.log("批量转存参数", arr);
      saveToVodBatch(arr).then((res) => {
        if (res.code === 0) {
          this.$message.success("后台转存中");
        } else {
          this.warning(res.msg);
        }
      });
    },
    setCover(url) {
      this.$emit("cover", url);
    },
    setShareCover(url) {
      this.$emit("shareCover", url);
    },
    //通用上传，目前主要用在添加链接时上传文件
    upload(file, callback) {
      this.showLoading = true;
      file.fromArticle = this.fromFunction === "article";
      uploadAttachment(file, "editorUpload").then((res) => {
        if (res.status == "fail") {
          this.warning("上传失败");
          this.showLoading = false;
          return;
        } else if (res.status == "success") {
          this.showLoading = false;
          this.$message.success("上传成功");
          callback(res.response.url);
          // if (this.power["添加"]) {
          //   //视频音频上传弹窗展示是否转存到媒资库的选项editorToMediaLibrary
          //   if (!this.uploadVideos && window.editorToMediaLibrary) {
          //     this.vodDialog = true;
          //   }
          //   this.url = res.response.url;
          // }
        }
      });
    },
    //上传链接文件
    uploadLinkFile() {
      let _this = this;
      let input = document.createElement("input"); //创建一个隐藏的input
      input.setAttribute("type", "file");
      input.onchange = function() {
        let file = this.files[0]; //选取第一个文件
        _this.upload(file, window.setEditorLink);
      };
      input.click();
    },
    //将富文本中的超链接解码
    changeLink(_str) {
      let str = _str;
      //中文名附件保存时不做解码处理，解决有空格时获取签名错误的问题(20240129)
      // let reg = /<a href=[^><]{0,}>/gi;
      // let arr = str.match(reg);
      // if (Array.isArray(arr) && arr[0]) {
      //   arr.forEach((item) => {
      //     let url = item.split('"')[1];
      //     str = str.replace(url, decodeURI(decodeURI(url)));
      //   });
      // }
      str = this.filterTags(str);
      return str;
    },
    //去除标签
    filterTags(str) {
      const regex = /onerror="[^"]*"|onclick="[^"]*"|onload="[^"]*"/g;
      str = str.replace(regex, "");
      // str = str.replaceAll(/<section\b[^>]*>(.*?)<\/section>/gs, "<p>$1</p>");
      str = str.replaceAll(/<figure\b[^>]*>(.*?)<\/figure>/gs, "<p>$1</p>");
      // str = str.replaceAll(/<strong\b[^>]*>(.*?)<\/strong>/gs, "<p>$1</p>");
      //对音频和视频加上禁止下载属性
      str = forbidMediaDownload(str);
      return str;
    },
    showMediaLibraryCheckbox() {
      if (!this.power["添加"]) {
        return;
      }
      window.editorToMediaLibrary = false;
      let firstElm = document.getElementsByClassName(
        "tox-dialog__footer-start"
      )[0];
      if (firstElm) {
        let div = document.createElement("div");
        div.setAttribute("class", "flex-align-center");
        let elm = document.createElement("input");
        elm.setAttribute("type", "checkbox");
        elm.setAttribute("style", "height:14px;width:14px;margin-top:1px");
        elm.onclick = function() {
          window.editorToMediaLibrary = elm.checked;
        };
        let elm2 = document.getElementsByClassName(
          "tox-dialog__footer-start"
        )[0];
        let father = document.getElementsByClassName("tox-dialog__footer")[0];
        div.appendChild(elm);
        let text = document.createElement("span");
        text.innerText = "转存媒资库";
        text.setAttribute(
          "style",
          "margin-left:5px;font-size:14px;font-weight:bold"
        );
        div.appendChild(text);
        if (father) {
          father.insertBefore(div, elm2);
        }
      }
      console.log("设置事件");
      let elm3 = document.getElementsByClassName("tox-dialog__footer")[0];
      if (elm3) {
        elm3 = elm3.getElementsByClassName("tox-button")[1];
      }
      if (elm3) {
        elm3.addEventListener("click", () => {
          console.log("点击了保存");
          if (this.url && window.editorToMediaLibrary) {
            this.vodDialog = true;
          }
        });
      }
      console.log("elm", elm3);
      return;
    },
  },
};
</script>

<style>
.setCoverImage :hover {
  color: slategrey;
}
</style>
<style scoped lang="scss">
/*
.tinymce-container {
  position: relative;
  z-index: 1116;
} */
/* .tox .tox-editor-header {
  z-index: 1200;
} */
.mce-preview-object {
  border: 0 !important;
}
.transparent-bg {
  position: absolute;
  background-color: transparent;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
}
// .tox ::v-deep .tox-dialog-wrap {
//   z-index: 1 !important;
// }
</style>
